<template>
	<el-select remote-show-suffix filterable clearable :style="{ 'width': `${width}` }" :disabled="disabled" :size="size"
		v-model="WarehouseId" :loading="loading" @focus="SelectFocus" :placeholder="placeholder"
		@change="WarehouseChange" @clear="WarehouseClear">
		<el-option v-for="v in WarehouseList" :key="v[ValueKey]" :label="v[LabelKey]" :value="v[ValueKey]" />
	</el-select>
</template>

<script lang="ts" setup>
import { ref, getCurrentInstance, withDefaults, onMounted, watch } from 'vue';
import translate from '@/api/translate';

interface main {
	id?: string | number,
	size?: string,
	ValueKey?: string,
	LabelKey?: string,
	width?: string | number,
	disabled?: boolean,
	IsAuto?: boolean,
};

const props = withDefaults(defineProps<main>(), {
	id: "",
	size: "default",
	ValueKey: "value",
	LabelKey: "label",
	width: "100%",
	disabled: false,
	IsAuto: false,
});

const { proxy } = getCurrentInstance() as any;
const emits = defineEmits(["update:id", "change", "clear"]);
const WarehouseId = ref<any>("");
const WarehouseList = ref<any>([]);
const loading = ref(false);
const placeholder = ref(translate.ShowText('请选择')); // 请选择...

watch(() => props.id, (n: any) => {
	WarehouseId.value = n;
});

onMounted(() => {
	WarehouseId.value = props.id;
	if (props.IsAuto) {
		if (proxy.$store.state.IsRefreshWarehouse) {
			GetData();
		} else {
			if (proxy.$store.state.WarehouseList.length > 0) {
				WarehouseList.value = proxy.$store.state.WarehouseList;
				if (!WarehouseId.value && WarehouseList.value.length == 1) {
					WarehouseId.value = WarehouseList.value[0].value;
					emits("update:id", WarehouseList.value[0].value);
					emits("change", WarehouseList.value[0].value);
				}
			} else {
				GetData()
			}
		}
	}
});

const WarehouseChange = (data: any) => {
	emits("update:id", data);
	emits("change", data);
};
const WarehouseClear = () => {
	emits("clear");
};
const SelectFocus = () => {
	if (proxy.$store.state.IsRefreshWarehouse) {
		GetData();
	} else {
		if (proxy.$store.state.WarehouseList.length > 0) {
			WarehouseList.value = proxy.$store.state.WarehouseList;
			if (!WarehouseId.value && WarehouseList.value.length == 1) {
				WarehouseId.value = WarehouseList.value[0].value;
				emits("update:id", WarehouseList.value[0].value);
				emits("change", WarehouseList.value[0].value);
			}
		} else {
			GetData()
		}
	}
};
const GetData = () => {
	loading.value = true;
	proxy.$api.tokenRequest({
		url: '/admin/warehouse/listByType',
		data: {
			type: 1,
		},
		success: (res: any) => {
			loading.value = false;
			WarehouseList.value = res.data;
			if (!WarehouseId.value && WarehouseList.value.length == 1) {
				WarehouseId.value = WarehouseList.value[0].value;
				emits("update:id", WarehouseList.value[0].value);
				emits("change", WarehouseList.value[0].value);
			}
			proxy.$store.commit("GetAllList", {
				type: 1,
				data: res.data,
			});
		},
		fail: () => {
			loading.value = false;
		},
	});
};
</script>

<style></style>